export default "__VITE_ASSET__BJ38AxhB__"